import Router from 'next/router';
import { useEffect, useRef } from 'react';
import StorageManager from '../../utils/storage-manager';

const SCROLL_POSITION_KEY = 'pd:scroll-position';
const scrollPositionsStore = new StorageManager<{ [location: string]: number }>(
  SCROLL_POSITION_KEY,
  'sessionStorage'
);

export const usePreserveScroll = (enable: boolean = true) => {
  const wasEnabled = useRef(false);

  useEffect(() => {
    if (!enable || wasEnabled.current) {
      return;
    }

    wasEnabled.current = true;
    const url = window.location.href;
    const scrollPositions = scrollPositionsStore.get() || {};

    if (url in scrollPositions) {
      // set delay to align with re-load on cdp until the height is set
      setTimeout(window.scrollTo, 500, 0, scrollPositions[url]);
    }

    const navigationHandler = () => {
      scrollPositions[url] = window.scrollY;
      scrollPositionsStore.set(scrollPositions);
      return true;
    };

    Router.events.on('routeChangeStart', navigationHandler);

    return () => {
      Router.events.off('routeChangeStart', navigationHandler);
      wasEnabled.current = false;
    };
  }, [enable]);
};
